export default "__VITE_ASSET__C2J5WPQM__"